import React from 'react'
import PropTypes from 'prop-types';
import * as gaConstants from './constants'

export default class GoogleAnalytics extends React.Component {
    render() {
        return (
            <GoogleProvider clientId={gaConstants.CLIENT_ID}>
                <GoogleDataChart views={gaConstants.views} config={gaConstants.accessFrom}/>
                <GoogleDataChart views={gaConstants.views} config={gaConstants.totalActiveUsers}/>
                <GoogleDataChart views={gaConstants.views} config={gaConstants.pathVisits}/>
            </GoogleProvider>
        );
    }
}

let isLoaded = false;

// wait for auth to display children
export class GoogleProvider extends React.Component {
    state = {
        ready: false,
        buttonLoaded: false,
    };

    componentDidMount() {
        this.init();
        if (this.authButtonNode) {
            this.authButtonNode.addEventListener('DOMSubtreeModified', () => {
                if (this.authButtonNode && this.authButtonNode.childNodes.length > 0) {
                    this.setState({buttonLoaded: true})
                }
            }, false);
        }
    }

    init = () => {
        const doAuth = () => {
            const authObj = this.props.accessToken ?
                {serverAuth: {access_token: this.props.accessToken}} :
                {clientid: this.props.clientId};

            gapi.analytics.auth &&
            gapi.analytics.auth.authorize({
                client_id: this.props.clientId,
                container: this.authButtonNode
            });


        };
        gapi.analytics.ready(a => {
            if (isLoaded) {
                this.setState({
                        ready: true
                });
                return;
            }
            const authResponse = gapi.analytics.auth.getAuthResponse();
            if (!authResponse) {
                gapi.analytics.auth.on("success", response => {
                    console.log("SUCCESS", response);
                    this.setState({
                        ready: true
                    });
                });
                gapi.analytics.auth.on("error", response => {
                    console.log("ERROR", response);
                });
            } else {
                console.log("Auth response");
                this.setState({
                    ready: true
                });
            }
            doAuth();
        });
    };

    render() {
        return (
            <div>
                {!this.state.buttonLoaded && (
                    <div className="main-loader">
                        <div className="loader-lg"></div>
                    </div>)
                }
                {this.props.clientId && <div ref={node => (this.authButtonNode = node)}/>}
                {this.state.ready && this.props.children}
            </div>
        );

    }
}

GoogleProvider.propTypes = {
    clientId: PropTypes.string,
    accessToken: PropTypes.string,
}

// single chart
export class GoogleDataChart extends React.Component {
    componentDidMount() {
        this.loadChart();
    }

    componentWillUpdate() {
        this.loadChart();
    }

    componentWillUnmount() {
        // TODO: cleanup
    }

    loadChart = () => {
        const config = {
            ...this.props.config,
            chart: {
                ...this.props.config.chart,
                container: this.chartNode
            }
        };
        this.chart = new gapi.analytics.googleCharts.DataChart(config);
        this.chart.set(this.props.views).execute();
    };

    render() {

        return (
            <div
                className={this.props.className}
                style={this.props.style}
                ref={node => (this.chartNode = node)}
            />
        );
    }
}